import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import App from './App';
import Header from './components/Header';
import Footer from './components/Footer';
import Playground from './pages/Playground';
import BigScreen from './pages/BigScreen';
import Creator from './pages/Creator';
import VisualValidate from './pages/VisualValidate';
import VisualValidateCallback from './pages/VisualValidate/Callback';
import 'semantic-ui-css/semantic.min.css';
import 'antd/dist/reset.css';
import './index.css';
import { UserProvider } from './context/User';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StatusProvider } from './context/Status';
import './i18n';

const Layout = () => {
  const location = useLocation();
  const isPlayground = location.pathname === '/playground';
  const isBigScreen = location.pathname === '/big-screen';
  const isCreator = location.pathname === '/creator';
  const isVisualValidate = location.pathname.startsWith('/visual-validate');

  if (isPlayground) {
    return <Playground />;
  }

  if (isBigScreen) {
    return <BigScreen />;
  }

  if (isCreator) {
    return <Creator />;
  }

  if (isVisualValidate) {
    return (
      <>
        {location.pathname === '/visual-validate/callback' ? (
          <VisualValidateCallback />
        ) : (
          <VisualValidate />
        )}
        <ToastContainer />
      </>
    );
  }

  return (
    <>
      <Header />
      <Container className={'main-content'}>
        <App />
      </Container>
      <ToastContainer />
      <Footer />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatusProvider>
      <UserProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </UserProvider>
    </StatusProvider>
  </React.StrictMode>
);
